<template>
  <div class="row">
    <div class="col-md-3"></div>
    <div class="col-md-12" style="padding: 10px">
      <el-table
        class="table-striped"
        header-row-class-name="text-primary"
        :data="charges_summary || []"
        style="width: 100%"
      >
        <el-table-column class-name="td-actions" label="Route">
          <template #default="{ row }">
            <div class="mb-2 fw-bold">{{ row.route_code }}</div>

            <el-table
              class="table-striped"
              header-row-class-name="text-primary"
              :data="row.items"
              style="width: 100%"
              size="small"
              border
            >
              <el-table-column label="Passenger Type">
                <template #default="{ row: item }">
                  <strong>{{ item.passenger_type }}</strong>

                  <table class="inner-table">
                    <thead>
                      <tr>
                        <th>Accommodation</th>
                        <th>Total Ticket Fare</th>
                        <th>Service Fee</th>
                        <th>Total Amount To Pay</th>
                        <th colspan="4">Maya Charges</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(price, i) in item.prices" :key="i">
                        <td>{{ row.route_code}} - {{ price.accommodation_code }}</td>
                        <td>{{ money(price.total_ticket_fare) }}</td>
                        <td>CHARGE: {{ price.online_charge }}% <span v-if="price.additional_charge">+ {{ money(price.additional_charge) }}</span><br>{{ money(price.service_fee) }}</td>
                        <td>{{ money(price.total) }}</td>

                        <td
                          v-for="(maya, j) in price.maya_charges"
                          :key="j"
                          class="maya-col"
                        >
                          <div class="maya-option">
                            {{ maya.payment_option }}
                          </div>

                          <div class="maya-rate">
                            Charge Rate: {{ maya.charge }}%
                            <span v-if="maya.additional_charge">
                              + ₱{{ maya.additional_charge }}
                            </span>
                          </div>

                          <div>
                            <el-tag type="warning">
                              Maya Fee: {{ money(maya.maya_charge) }}
                            </el-tag>
                          </div>

                          <el-tag
                            :type="maya.admin_fee < 0 ? 'danger' : 'primary'"
                          >
                            Admin Fee: {{ money(maya.admin_fee) }}
                          </el-tag>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["charges_summary"],
  data() {
    return {};
  },
};
</script>

<style lang="scss">

.inner-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  font-size: 12px;
}

.inner-table th,
.inner-table td {
  border: 1px solid #ebeef5;
  padding: 6px;
  vertical-align: top;
}

.maya-col {
  min-width: 160px;
}

.maya-option {
  font-weight: 600;
}

.maya-rate {
  font-size: 12px;
  opacity: 0.85;
}

</style>
